module.exports = __webpack_public_path__ + "img/new_icon_house.3706973d.png";